import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ExcursionServiceService } from '../service/excursion-service.service';
import { AuthService } from '../service/auth.service';
import { DataServiceService } from '../service/data-service.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
@Component({
  selector: 'app-logintemplate',
  templateUrl: './logintemplate.component.html',
  styleUrls: ['./logintemplate.component.css']
})
export class LogintemplateComponent implements OnInit {
  @ViewChild("myInput")
  private _inputElement!: ElementRef;
  token: any;
  loginForm=new FormGroup({
    username:new FormControl('',Validators.required),
    password:new FormControl('',Validators.required)
  });
  appClient: string = environment.appClient;
  baseAppName: string = environment.baseAppName;
  logoImg: string = "/" + this.baseAppName + "/assets/img/logo/royal_park_logo.png";
  royalgulfImg: string = "/" + this.baseAppName + "/assets/img/logo/royal_gulf_logo.png";

  constructor(private excursionServiceService:ExcursionServiceService,private auth_service:AuthService,
    private toastrService: ToastrService,private route: ActivatedRoute,
    private  dataService:DataServiceService,private router: Router) { }

  ngOnInit(): void {
    window.setTimeout(() => {
      // console.log('setting focus now');
      this._inputElement.nativeElement.focus();
  }, 10);

  if(this.appClient == "RoyalPark"){
    this.logoImg = "/" + this.baseAppName + "/assets/img/logo/royal_park_logo.png";
    this.royalgulfImg = "/" + this.baseAppName + "/assets/img/logo/royal_gulf_logo.png";
  }
  else if(this.appClient == "RoyalAdventure"){
    this.logoImg = "/" + this.baseAppName + "/assets/img/logo/royal_adv_logo.png";
  }

  if(!environment.production){
    //console.log(environment.appClient);
    this.toastrService.success('This App is running in development server', '',{closeButton:true, timeOut: 3000});
  }
  
  this.route.queryParams.subscribe(params=>{
    console.log(params['Token']);
    this.token = params['Token'];

    let qry = params['q'];
    if(qry != undefined && qry != ""){
      let nav = "";
      nav = "/supplier-confirmation";
      this.router.navigate([nav],{ queryParams: { q: qry } });
    }

  });

  const jsonData = { Token: this.token};
  if(this.token !== undefined || this.token !== null || this.token !== ""){
    console.log(this.token);
    this.internal_login_validate(jsonData);
  }
  
  }

  internal_login_validate(data: {}){
    console.log(data + ' inside funtion');
    this.excursionServiceService.internal_login_validate(data).subscribe((res: { [x: string]: any; })=>{
      console.log(res);
      if (res['data'][0]['isAuthendicatedLogin']==1){
        this.auth_service.setMenu(res['menu_rights']);
        this.auth_service.setUser(res['data'][0])
        //this.dataService.menuRightsList = res['menu_rights'];
      }
    });
  }

  login_FormSubmit(){
    ////console.log(this.loginForm.value);
    this.login_validate(this.loginForm.value);
    
  }

  gaLogin(result: string){
    gtag('event','login',{
      event_category:'authentication',
      event_label:"User Login",
      username:this.loginForm.value.username,
      password:"******",
      result: result
    });
  }

  login_validate(data: {}){
    this.excursionServiceService.login_validate(data).subscribe((res: { [x: string]: any; })=>{
      ////console.log(res)
      if (res['result']==1){
        if(res['data'].length==0){
          this.toastrService.error('Invalid User', 'Title Error!',{closeButton:true, timeOut: 3000});
          this.gaLogin("Invalid User");
          return;
        }

        if(res['menu_rights'].length==0){
          this.toastrService.error('You dont have rights to this application', 'Title Error!',{closeButton:true, timeOut: 3000});
          return;
        }
        ////console.log(res['data'][0]['username']);
        this.gaLogin("Success");
        this.auth_service.setMenu(res['menu_rights']);
        this.auth_service.setUser(res['data'][0]);
        //this.dataService.menuRightsList = res['menu_rights'];
        //console.log(this.dataService.menuRightsList);
        //this.excursionlist=res['data']
        //this.loading=false
        //this.loadsupplierdetails({})
      }
      else{
        this.toastrService.error('Invalid User', 'Title Error!',{closeButton:true, timeOut: 3000});
        this.gaLogin("Invalid User");
      }
    });
  }
  sendPsw(){
    let data=this.loginForm.value
    this.excursionServiceService.forgotPsw(data).subscribe((res: { [x: string]: any; })=>{
      if(res['data'].length==1){
        this.toastrService.error('Message was send to your mail', 'Title Success!',{closeButton:true, timeOut: 3000});
        return
      }
      else{
        this.toastrService.error('Please send valid username', 'Title Error!',{closeButton:true, timeOut: 3000});
      }

    })
  }
}
